import axios from 'axios'
import { push } from 'react-router-redux'
import l8n from 'l8n'

import {setUser, getUser, setFrom, getCurrentUser, getAccessToken, removeUser} from './app'

// Отказ в аутентификации, редирект на форму логина
export const rejectAuth = () => (dispatch, getState) => {
    const state = getState()
    const location = state.routing.location
    const from = location.pathname + location.search

    dispatch(setFrom(from))
    dispatch(removeUser())
    console.log('Redirecting to /login');
    dispatch(push('/' + l8n.locale + '/login'))

    return Promise.reject()
}

// Аутентификация. Запускается на каждой странице, для которой в props передан массив допустимых ролей
export const initAuth = roles => async (dispatch, getState) => {
    const state = getState()
    const user = getCurrentUser(state)
    const token = getAccessToken(state)

    try {
        // Есть токен
        if (token && token.payload) {
            // Все последующие запросы будут со стандартным заголовком
            axios.defaults.headers.common['Authorization'] = token.payload;

            if (!user.id) {
                //console.log("User Not Authorized but Hash presented")
                // Узнаем данные пользователя
                const user_fetched = await dispatch(getUser())
                // Если узнали, то начинаем все заново
                if (user_fetched) {
                    return dispatch(initAuth(roles))
                } else {
                    return dispatch(rejectAuth())
                }
            // Есть юзер
            } else {
                //console.log("User Authorized")
                dispatch(setUser(user))
                if (!roles.find(role => role === user.role)) {
                    if (!(getState().routing.location.pathname === '/')) {
                        //console.log("No Access by User Role; Redirect to /")
                        dispatch(push('/'))
                    }
                    //console.log("Auth false")
                    return Promise.resolve(false)
                }
                //console.log("Auth true")
                return Promise.resolve(true)
            }
        // Нет токена    
        } else {
            return dispatch(rejectAuth())
        }
    } catch (err) {
        //console.log(err)
        return dispatch(rejectAuth())
    }
}



// WEBPACK FOOTER //
// ./src/ducks/auth.js